import React, { useEffect } from "react";
import { ModalType } from "../modal/LeadModal";
import { NavLinks } from "./NavLinks";
import { useAuth } from "../../context/AuthContext";
import { HeaderActions } from "./HeaderActions";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onOpenModal: (type: ModalType) => void;
};

export const MobileMenu: React.FC<Props> = ({ isOpen, onClose, onOpenModal }) => {
    const { loading } = useAuth();
    const canShowAuthButtons = !loading;

    useEffect(() => {
        if (!isOpen) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };

        document.addEventListener("keydown", onKeyDown);

        // scroll lock
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = prevOverflow;
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleNavClick = () => onClose();

    return (
        <div className="mobile-menu-backdrop" onClick={onClose} role="presentation">
            <aside
                id="mobile-menu"
                className="mobile-menu"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label="Меню"
            >
                <div className="mobile-menu-header">
                    <span className="mobile-menu-title">Меню</span>
                    <button
                        className="mobile-menu-close"
                        type="button"
                        onClick={onClose}
                        aria-label="Закрыть меню"
                    >
                        ✕
                    </button>
                </div>

                <nav className="mobile-menu-nav" aria-label="Навигация">
                    <NavLinks variant="mobile" onNavigate={handleNavClick} />
                </nav>

                <HeaderActions
                    variant="mobile"
                    canShowAuthButtons={canShowAuthButtons}
                    onOpenModal={onOpenModal}
                    onNavigate={handleNavClick}
                />
            </aside>
        </div>
    );
};
